module.exports = __webpack_public_path__ + "img/app_multi_site.44625cf5.svg";